import { createAction, createReducer } from 'redux-act';
import { createSelector } from 'reselect';
import ConfigBag from '@gandi/config-bag';
const selectConfig = createSelector([state => state.config], config => {
  const configBag = new ConfigBag();
  configBag.merge(config);
  return configBag;
});
export const selectFromConfig = (key, defaultValue) => createSelector([selectConfig], config => config.get(key, defaultValue));
export const initConfig = createAction('Init configuration');
export const configReducer = createReducer({
  [initConfig.getType()]: (state, payload) => ({
    ...state,
    ...payload
  })
}, {});